'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataAggregateRow: ()=>DataAggregateRow
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../Table/index.cjs");
const DataAggregateRow = ({ table, position, aggregatedData })=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.Tr, {
        children: [
            table.options.enableMultiRowSelection && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Td, {
                className: "border-y-1 border-black"
            }, `${position}-aggregate-checkbox`),
            table.getAllColumns().map((column)=>{
                const cellProps = column.columnDef.meta?.cellProps || {};
                const aggregatedCell = column.columnDef.meta?.aggregate?.cell;
                const aggregatedValue = aggregatedData[position]?.[column.id];
                const cellContent = 'function' == typeof aggregatedCell ? aggregatedCell(aggregatedValue) : aggregatedValue;
                return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.Td, {
                    className: "border-y-1 border-black font-bold",
                    ...cellProps,
                    children: ('string' == typeof cellContent || 'number' == typeof cellContent || /*#__PURE__*/ external_react_default().isValidElement(cellContent)) && cellContent
                }, `aggregate-${column.id}-${position}`);
            })
        ]
    }, `${position}-aggregate-row`);
exports.DataAggregateRow = __webpack_exports__.DataAggregateRow;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataAggregateRow"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
